import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ProblemForUserStoreEffects } from './effects';
import { problemReducer } from './reducer';
import { ProblemForUserFacade } from './facade';
import { stateName } from './selectors';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(stateName, problemReducer), EffectsModule.forFeature([ProblemForUserStoreEffects])],
  exports: [],
  providers: [ProblemForUserFacade],
  declarations: [],
})
export class ProblemForUserStateModule {}
